import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import '../styles/PaymentResult.css';

const Success = () => {
  const [searchParams] = useSearchParams();
  const [paymentId, setPaymentId] = useState('');

  useEffect(() => {
    const id = searchParams.get('id') || '';
    setPaymentId(id);
  }, [searchParams]);

  const handleWhatsAppClick = () => {
    const phoneNumber = process.env.REACT_APP_WHATSAPP_NUMBER || '5491112345678';
    const message = paymentId 
      ? `Hola, realicé mi compra #${paymentId}`
      : 'Hola, realicé mi compra';
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div className="payment-result-container">
      <div className="payment-result-content">
        <div className="payment-result-icon success-icon">
          ✅
        </div>
        <h1 className="payment-result-title">¡Pago Exitoso!</h1>
        <p className="payment-result-message">
          Tu pago se ha procesado correctamente. 
          {paymentId && (
            <span className="payment-id"> Tu código de compra es: <strong>#{paymentId}</strong></span>
          )}
        </p>
        <p className="payment-result-submessage">
          Te contactaremos pronto para coordinar la entrega de tu pedido.
        </p>
        
        <div className="payment-result-actions">
          <button 
            className="btn btn-whatsapp btn-large payment-whatsapp-btn"
            onClick={handleWhatsAppClick}
          >
            <span>💬</span>
            Contactar por WhatsApp
          </button>
          
          <Link to="/" className="btn btn-secondary payment-home-btn">
            Volver al inicio
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Success;


